import { toast } from "@/components/ui/sonner";

/** Trigger the PWA install prompt, with an instructional fallback. */
export const promptInstall = async () => {
  const prompt = (window as any).deferredInstallPrompt;
  if (prompt) {
    await prompt.prompt();
    const { outcome } = await prompt.userChoice;
    if (outcome === "accepted") {
      toast.success("Installing AiMediQ™...");
    }
    (window as any).deferredInstallPrompt = null;
  } else {
    toast("Install this app", {
      description: "Tap your browser menu (or Share on iOS) and choose 'Add to Home Screen'.",
      duration: 6000,
    });
  }
};
